<template>
    <table id="order-summary-table" class="order">
        <tbody>
        <tr>
            <th class="expand"><slot name="title"></slot></th>
            <th class="text-right shrink"><slot name="price"></slot></th>
        </tr>
        <tr v-for="item in items" v-if="item.active && item.quantity > 0 && (item.one_time || (days.length > 0))">
            <td class="expand"><span v-html="item.title"></span><b v-if="item.quantity > 1"> (x{{item.quantity}})</b><b v-if="(days.length > 1) && !item.one_time"> (x{{days.length}})</b></td>
            <td class="text-right shrink" v-html="
                priceCHF(Math.floor((
                    item.one_time ? (item.price * (item.discount && item.discount > 0 ? Math.max(0, item.quantity - item.discount) : item.quantity) )
                    : ((item.price * item.quantity *  days.length) - (item.discount && item.discount > 0 ? item.price * item.discount : 0))
                ) * 100) / 100)
            "></td>
        </tr>

        <tr class="order__total">
            <td class="shrink">Total</td>
            <td class="text-right shrink" v-html="CHF (getTotal())"></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
  import { formatMoney } from 'accounting-js'
export default {
    props: {
        tableitems: Array,
        tabledays: Array,
        priceCHFHandler: Function,
    },
    data() {
        return {
            items: this.tableitems,
            days: this.tabledays ? this.tabledays : []
        }
    },
    mounted() {
        this.$root.$on('eventChangeQty', (type, id, quantity) => {

            this.updateOrderItemQuantity(type, id, quantity);
        })
    },
    methods: {
        computeQuantity: function(item) {

        },
        getTotal: function(){
            var sum = 0;

            for(var i = 0; i < this.items.length; i += 1) {

                var item = this.items[i];

                if (item.active) {
                    if (!item.one_time) {
                        sum += ((item.price * (item.quantity > 0 ? item.quantity : 0 )) * this.days.length) - (item.discount && item.discount > 0 ? item.price * item.discount : 0);
                    }
                    else {
                        sum += item.price * (item.quantity > 0 ? (
                            (item.discount && item.discount > 0 ? Math.max(0, item.quantity - item.discount) : item.quantity)
                        )
                         : 0 );
                    }
                }
            }



            return Math.floor(sum * 100) / 100;
        },
        toggleOrderDay: function(id, active) {
            if (active && (this.days.indexOf(id) == -1)) {
                this.days.push(id);
            }
            else if (!active) {
                this.days.splice(this.days.indexOf(id), 1);
            }

            for(var i = 0; i < this.items.length; i += 1) {
                if(this.items[i]['day_linked'] === true) {

                    var newItem = this.items[i];
                    newItem.active = this.items[i]['day_id'] == id ? active : this.items[i].active;
                    newItem.quantity = this.items[i]['day_id'] == id && !active ? 0 : this.items[i].quantity;

                    Vue.set(this.items, i, newItem);
                }
            }

        },
        updateOrderItem: function(type, id, active, linked) {
            for(var i = 0; i < this.items.length; i += 1) {

                if(this.items[i]['refer'] === type) {
                    if(this.items[i]['id'] === id) {

                        var newItem = this.items[i];
                        newItem.active = active;

                        Vue.set(this.items, i, newItem);
                    }
                    else {
                        if (linked && active) {
                            var otherItem = this.items[i];
                            otherItem.active = !active;

                            Vue.set(this.items, i, otherItem);
                        }
                    }
                }
            }
        },
        updateOrderItemQuantity: function(type, id, quantity) {
            for(var i = 0; i < this.items.length; i += 1) {
                if(this.items[i]['refer'] === type) {
                    if(this.items[i]['id'] === id) {
                        var newItem = this.items[i];
                        newItem.quantity = quantity;

                        Vue.set(this.items, i, newItem);
                    }
                }
            }
        },
        updateOrderItemDiscount: function(type, id, discount) {
            for(let i = 0; i < this.items.length; i += 1) {
                if(this.items[i]['refer'] === type) {
                    if(this.items[i]['id'] === id) {
                        const newItem = this.items[i];
                        newItem.discount = discount;

                        Vue.set(this.items, i, newItem);
                    }
                }
            }
        },
        updateOrderItemPrice: function(type, id, price) {
            for(let i = 0; i < this.items.length; i += 1) {
                if(this.items[i]['refer'] === type) {
                    if(this.items[i]['id'] === id) {
                        const newItem = this.items[i];
                        newItem.price = price;

                        Vue.set(this.items, i, newItem);
                    }
                }
            }
        },
      // helper's method translated in js, using accounting-js library
      /**
       * @return {string}
       */
      CHF(amount){
        return formatMoney(amount, {symbol: 'CHF ', precision: 2, thousand : "'" , decimal: ","}).concat('.-').replace('CHF' ,'<span class="price__currency">CHF</span>');
      },
      priceCHF(amount){
        return formatMoney(amount, {symbol: 'CHF ', precision: 2, thousand : "'" , decimal: ","}).concat('.-').replace('CHF', '');
      },

    },

}

</script>
